import { defaultFill } from './utils/constants';
var muiTruthmarkBase = {
    paths: [
        {
            path: 'M10.073487,3.17343254 C5.11847646,4.22225214 1.22046257,9.92991753 3.84154088,15.8782341 C5.41981211,19.2310393 8.70341604,20.8768912 11.0261256,21 C11.94974,19.9906632 14.8405498,16.9063414 15.8014442,15.8614053 C11.9212318,15.8614053 11.1147462,15.9596593 10.2680136,15.4962214 C7.30045095,13.8726352 7.25839812,9.59567263 10.8179254,8.30529571 C12.8756763,7.66062506 15.8281464,8.9355972 15.8281464,12.3021243 C15.8281464,13.525704 15.8587186,12.2797291 15.809055,15.8614053 L15.809055,20.6487969 L21,20.6487969 L21,11.8775219 C21,6.96352638 16.4602289,2.00279867 10.073487,3.17343254',
            fill: defaultFill,
        },
    ],
    title: 'truthmark',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [0, 0],
};
var muiTruthmark = {
    base: muiTruthmarkBase,
};
export { muiTruthmark };
//# sourceMappingURL=truthmark.js.map